<section>
  <header>
    <h1 auto="envisioning-title">Envisioning Phase</h1>
  </header>
  <div class="information-container">
    <div>
      <p><strong>Determine Current Reality</strong></p>
      <p>
        The Envisioning Phase expands an institution’s view of its current reality and potential future to establish a foundation for decision-making around goals and strategies for the institution. The Determine Current Reality subphase provides an important snapshot of the institution’s everyday experiences through the lens of learners and other key stakeholders in its community. This subphase is an organizer that allows you to collect and analyze information about the learners, institution, and community.
      </p>
      <p>
        In the Determine Current Reality subphase, decide what information is most relevant and accessible for review for each stakeholder group. Then, analyze the information sets to determine what was learned for each stakeholder group. Finally, pinpoint connections from the analysis to identify topics or themes about your institution's current reality.
      </p>
    </div>
  </div>
  <div class="explanation-margin">
    <div class="download-guide-container">
      <img class="book-icon pointer" src="assets/images/download-guide-icon.svg" alt="book-icon" (click)="openGuide()">
      <span class="download-tagline pointer" (click)="openGuide()">Download the guide</span> to learn more about <strong>Determine Current Reality</strong>.
    </div>
  </div>
</section>
<section>
<app-category-information [categoryLabel]="'Learner'"
                          [categoryColor]="'#324d5b'"
                          [category]='learner'
                          pageValue="DCR"
                          categoryValue="L"
                          [isViewer]="isViewer()"
                          (addAttachment)="showAttachmentUploadModal($event)"
                          (editAttachment)="showAttachmentEditModal($event)"
                          (deleteAttachment)="onClickDeleteItem($event.resource, $event.label)"></app-category-information>
<app-category-information [categoryLabel]="'Institution'"
                          [categoryColor]="'#45b39d'"
                          [category]='institution'
                          pageValue="DCR"
                          categoryValue="I"
                          [isViewer]="isViewer()"
                          (addAttachment)="showAttachmentUploadModal($event)"
                          (editAttachment)="showAttachmentEditModal($event)"
                          (deleteAttachment)="onClickDeleteItem($event.resource, $event.label)"></app-category-information>
<app-category-information [categoryLabel]="'Community'"
                          [categoryColor]="'#03bbbf'"
                          [category]='community'
                          pageValue="DCR"
                          categoryValue="C"
                          [isViewer]="isViewer()"
                          (addAttachment)="showAttachmentUploadModal($event)"
                          (editAttachment)="showAttachmentEditModal($event)"
                          (deleteAttachment)="onClickDeleteItem($event.resource, $event.label)"></app-category-information>
</section>

<app-attachment-upload-modal #attachmentUploadModal
                             [strategyId]="strategyId"
                             (resourceEdit)="editResource($event)"
                             (resourceCreated)="fetchData()"
                             (resourcesChange)="fetchData()"
></app-attachment-upload-modal>

<p-dialog #confirmDeleteDialog styleClass="strategies-delete-dialog" [modal]="true" [closable]="false"
          appendTo="body">
  <p-header class="strategies-delete-dialog-header">
    <img src="assets/images/t-warning.svg" alt="Alert">
    <span class="dialog-title">Delete Information</span>
  </p-header>
  <div><strong>Are you sure you want to delete this information?</strong></div>
  <div>You are about to delete:</div>
  <div><strong><i>{{ itemLabel }}</i></strong></div>
  <div>Once the information has been deleted, it can not be undone.</div>
  <p-footer>
    <button auto="delete-cancel-btn" class="btn btn-alt" type="button" pButton label="Cancel"
            (click)="confirmDeleteDialog.visible = false">
    </button>
    <button auto="delete-confirm-btn" class="btn" type="button" pButton label="Delete"
            (click)="onConfirmDeleteDialogAccept()"></button>
  </p-footer>
</p-dialog>
